module.exports = __webpack_public_path__ + "img/1.988a2a2e.jpg";